import { DataBean } from "../../../DataBean";



export class HealthLOINCIMP extends DataBean {

    public async importHealthLOINCCatalog( media: any, mediaContext: any,directory:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importHealthLOINCCatalog_String_String_String", [ media, mediaContext,directory]);
    }

}